define.alias("shared/components/shared/upgrade/plan-highlight", "media/components/shared/upgrade/plan-highlight");